import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobDeleteComponent } from './job-delete.component';

const routes: Routes = [{ path: '', component: JobDeleteComponent, data: { title: 'Delete Job' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobDeleteRoutingModule {}

@NgModule({
  imports: [
    JobDeleteRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [JobDeleteComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobDeleteModule {}
